// Статичні підписи СЕС «Лучки» з проєктної документації, яких немає в таблиці
// адресації. Кожне значення — дослівно з креслення 1453LG_1_Strabychovo-ЕТР1
// («Схема електрична загальна», стадія РП); назви виробників — як у «ТЗ для
// EMS box» ред. 3.1 і ТЗ SLD від 21.10.2026. Нічого не додано «від себе».
import type { StationDrawing } from './sldTypes';

export const LUCHKY_DRAWING: StationDrawing = {
  source: 'Креслення 1453LG_1_Strabychovo-ЕТР1 «Схема електрична загальна» (РП)',
  grid: {
    substation: 'ПС 110/10 кВ «ЦЗП ФЕС»',
    transformer: 'ТДН-16000-110',
    transformerRating: '16 000 кВА · 110/10 кВ',
    switchgear: 'ЗРУ-10кВ',
  },
  vendors: { bess: 'Kehua', bank: 'Jinko', pv: 'GoodWe' },
  ratings: {
    bessBlock: '4000 кВт / 4400 кВА · 10/0,69 кВ',
    pcs: '1000 кВт / 1100 кВА',
    inverter: '250 кВт / 250 кВА',
    inverterKw: 250,
  },
  ktp: {
    'КТП-1': { mvs: 'GW5000K-MVS', rating: '5000 кВА · 10/0,8/0,8 кВ' },
    'КТП-2': { mvs: 'GW7000K-MVS', rating: '7000 кВА · 10/0,8/0,8 кВ' },
    'КТП-3': { mvs: 'GW5000K-MVS', rating: '5000 кВА · 10/0,8/0,8 кВ' },
  },
  groupOnDrawing: { D1: 'B', D2: 'A' },
  panels: '6480 × 625 Вт + 29520 × 620 Вт · 22,35 МВт',
};
